import EndNow from './end_now'
import { connect } from 'react-redux'
import { endNowRemotely } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'
import preventNavigation from 'components/common/prevent_navigation'
import { withRouter } from 'react-router'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    operatingRemotely: campaign.operatingRemotely,
    error: campaign.err,
  }
}

const mapDispatchToProps = (dispatch, { campaignId, router }) => {
  return {
    onEndNow() {
      return dispatch(endNowRemotely(campaignId))
        .then(() => {
          router.go(-2)
        })
        .catch(err => {
          console.error(err) // eslint-disable-line no-console
        })
    },
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(preventNavigation(EndNow, props => props.operatingRemotely))
)
